<template>
  <div v-if="$can('create-time_offs')">
    <button class="btn time-off button btn-success" v-if="isAvailableAdd" :title="isAvailableAdd ? '' : 'Please log in to Jira'" @click="showForm = true">Add time off</button>
    <TimeOffFormModal
      v-if="showForm"
      v-model="showForm"
      mode="create"
      :dataProps="formDataProps"
      :modal="true"
      :show-preloader="true"
      :isModalLoading="isModalLoading"
      @save="addTimeOff"
    />
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import { mapActions } from 'vuex'
import Moment from 'moment/moment'
import TimeOffFormModal from '../components/modals/TimeOffFormModal.vue'

export default {
  name: 'TimeOffAdd',
  components: { TimeOffFormModal },
  props: {
    user: {
      type: Object,
      default () {
        return null
      }
    },
    date: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      timeOff: null,
      isModalLoading: false,
      showForm: false,
      form: {}
    }
  },
  watch: {
    'item': {
      deep: true,
      immediate: true,
      handler (item) {
        this.timeOff = item
      }
    }
  },
  computed: {
    Moment () {
      return Moment
    },
    isAvailableAdd () {
      return !this.user || this.getUser.id === this.user.id
    },
    formDataProps () {
      if (this.date !== '') {
        return { date_from: Moment(this.date).format('YYYY-MM-DD'), date_to: Moment(this.date).format('YYYY-MM-DD') }
      } else {
        return { date_from: Moment().format('YYYY-MM-DD'), date_to: Moment().format('YYYY-MM-DD') }
      }
    }
  },
  methods: {
    ...mapActions({
      setIsModalLoading: 'finances/setIsModalLoading'
    }),
    addTimeOff (data) {
      this.isModalLoading = true
      this.$api.timeOffs.createTimeOff(data)
        .then(({ data, status }) => {
          this.$snotify.success(
            'Time off successfully created',
            'Success',
            this.$store.state.snotify
          )
          this.hideTimeOffsModal()
          this.timeOff = cloneDeep(data)
          this.$emit('createdTimeOff', { data: this.timeOff, status })
        })
        .catch(error => {
          this.errorNotifications(error)
        })
        .finally(() => {
          this.isModalLoading = false
        })
    },
    showTimeOffsModal () {
      this.showForm = true
      this.form = cloneDeep(this.timeOff)
    },
    hideTimeOffsModal () {
      this.showForm = false
      this.isModalLoading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.time-off {
  min-width: 120px;
  height: 30px;
  // margin-right: 15px;
  // margin-left: 15px;
}
</style>
